<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "EinspeisebeteiligungContactForm",
  data: () => ({
    showContactDialog: false,
    contactForm: {
      submitted: false,
      name: '',
      phone: '',
      mail: '',
      message: '',
    }
  }),
  watch: {
    showContactDialog(val) {
      if (!val) {
        this.contactForm = {
          submitted: false,
          name: '',
          phone: '',
          mail: '',
          message: '',
        };
      }
    }
  },
  computed: {
    ...mapGetters('user', ['userCommunePartner']),
    contactPersonImage() {
      const apiUrl = process.env.VUE_APP_API_BASE_URL;
      if (this.userCommunePartner.image && this.userCommunePartner.image.formats.small) {
        return apiUrl + this.userCommunePartner.image.formats.small.url;
      } else if (this.userCommunePartner.image && this.userCommunePartner.image.url) {
        return apiUrl + this.userCommunePartner.image.url;
      } else {
        return undefined;
      }
    },
    enableSubmitButton() {
      return !!this.contactForm.name.trim() &&
          !!this.contactForm.phone.trim() &&
          !!this.contactForm.mail.trim() &&
          !!this.contactForm.message.trim();
    },
  },
  methods: {
    ...mapActions('einspeisebeteiligung', ['sendContactMail']),
    async onContactFormSubmit() {
      await this.sendContactMail(this.contactForm);
      this.contactForm.submitted = true;
    },
  }
}
</script>

<template>
  <v-sheet class="contact-sheet pa-5">
    <p class="font-weight-bold  white--text">FORDERN SIE JETZT IHRE INDIVIDUELLE BERATUNG AN:</p>
    <v-dialog v-model="showContactDialog" width="500">
      <template v-slot:activator="{ on }">
        <v-btn class="primary-text" v-on="on">
          <v-icon left color="primary">mdi-email-outline</v-icon>
          <span class="primary-text">Per E-Mail anfragen</span>
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <div>
            <v-btn
                icon
                style="position: absolute; top: 10px; right: 10px"
                @click="showContactDialog = false"
                color="primary"
                plain
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <div v-if="!contactForm.submitted" class="text-center text-h5 font-weight-bold py-2"
               style="width: 100%">
            Ihre Anfrage
          </div>
        </v-card-title>
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" class="text-center">
              <v-avatar class="mx-auto icon-bg avatar-border" size="75" style="border: #8C0F78">
                <v-img v-if="contactPersonImage" :src="contactPersonImage" />
                <v-icon v-else size="75" color="#ffffff80">$user</v-icon>
              </v-avatar>
              <div class="text-center font-weight-bold">
                {{ userCommunePartner.firstname }} {{ userCommunePartner.lastname }}
              </div>
            </v-col>
          </v-row>
          <v-form v-if="!contactForm.submitted" @submit.prevent="onContactFormSubmit">
            <v-text-field
                label="Ihr Name"
                v-model="contactForm.name"
                outlined
                dense
                background-color="#B4005520"
                required />
            <v-text-field
                label="Ihre Telefonnummer"
                v-model="contactForm.phone"
                outlined
                dense
                background-color="#B4005520"
                required />
            <v-text-field
                label="Ihre E-Mail Adresse"
                v-model="contactForm.mail"
                outlined
                dense
                background-color="#B4005520"
                required />
            <v-textarea
                label="Ihre Nachricht"
                v-model="contactForm.message"
                outlined
                dense
                background-color="#B4005520"
                placeholder="Bitte beschreiben Sie kurz ihr Anliegen"
                required />
            <div style="width: 100%; display: flex">
              <v-btn color="primary" class="mx-auto px-10" type="submit" :disabled="!enableSubmitButton">
                Abschicken
              </v-btn>
            </div>
          </v-form>
          <div v-else class="text-center">
            <div class="text-center font-weight-bold text-h4 my-5">Vielen Dank!</div>
            <p>Ihre Anfrage ist bei uns eingegangen. Wir melden uns schnellstmöglich bei Ihnen zurück</p>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-sheet>
</template>

<style scoped>
.contact-sheet {
  background: transparent linear-gradient(74deg, #931880 0%, #B40055 100%) 0% 0% no-repeat padding-box;
  border-radius: 5px;
}

.avatar-border {
  border: #9c0047 solid 4px !important;
}
</style>
